import axios from 'axios';
import Vue from 'vue';

const environment_url = window.location.hostname.split('.').pop();
const base = `${window.location.protocol}//api.campbellcloud.${environment_url}`;
export const loginUrl = `${window.location.protocol}//login.campbellcloud.${environment_url}`;
const baseURLv2 = `${base}/api_v2`;
const baseURLv3 = `${base}/v3`;
export const domain = `campbellcloud.${environment_url}`;
export const protocol = window.location.protocol;


axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if(error.request && error.request.status == 401){
    console.error(`Authorization Error, logging out session`);
    Vue.prototype.$s.logout();
  }
  return Promise.reject(error);
});

export default {

  getUser({ id }) {
    return axios({
      url: `${baseURLv2}/user/${id}/get`,
      method: "GET",
      headers: {
        ...Vue.prototype.$s.SessionAuthToken(),
      },
    });
  },

  getDashboards({ vendor, organizationId, brief = false }) {
    return axios({
      url: `${baseURLv3}/${vendor}/organizations/${organizationId}/dashboards?brief=${brief}`,
      method: "GET",
      headers: {
        ...Vue.prototype.$s.SessionAuthToken(),
      },
    });
  },

  createDashboard({ vendor, organizationId, dashboard }) {
    return axios({
      url: `${baseURLv3}/${vendor}/organizations/${organizationId}/dashboards`,
      method: "POST",
      headers: {
        ...Vue.prototype.$s.SessionAuthToken(),
      },
      data: dashboard,
    });
  },

  updateDashboard({ vendor, organizationId, slug, updates }) {
    return axios({
      url: `${baseURLv3}/${vendor}/organizations/${organizationId}/dashboards/${slug}`,
      method: "PUT",
      headers: {
        ...Vue.prototype.$s.SessionAuthToken(),
      },
      data: updates,
    });
  },

  getDashboard({ vendor, organizationId, dashboardId }) {
    return axios({
      url: `${baseURLv3}/${vendor}/organizations/${organizationId}/dashboards/${dashboardId}`,
      method: "GET",
      headers: {
        ...Vue.prototype.$s.SessionAuthToken(),
      },
    });
  },

  deleteDashboard({ vendor, organizationId, dashboardId }) {
    return axios({
      url: `${baseURLv3}/${vendor}/organizations/${organizationId}/dashboards/${dashboardId}`,
      method: "DELETE",
      headers: {
        ...Vue.prototype.$s.SessionAuthToken(),
      },
    });
  },

  getUserStationBatch({ vendor, resourceId, organizationId, limit, skip, brief }) {
    return axios({
      url: `${baseURLv3}/${vendor}/organizations/${organizationId}/resources/${resourceId}/stations?skip=${skip}&limit=${limit}&brief=${brief}`,
      method: 'get',
      headers: Vue.prototype.$s.SessionAuthToken(),
    });
  },

  getUOMGroups() {
    return axios({
      url: `${base}/v2/unit_of_measure/groups`,
      method: 'get',
      headers: Vue.prototype.$s.SessionAuthToken(),
    });
  },

  getUOMSubtypes() {
    return axios({
      url: `${base}/v2/unit_of_measure/subtypes`,
      method: 'get',
      headers: Vue.prototype.$s.SessionAuthToken(),
    });
  },

  getUOMUnits() {
    return axios({
      url: `${base}/v2/unit_of_measure/units`,
      method: 'get',
      headers: Vue.prototype.$s.SessionAuthToken(),
    });
  },

  getMeasurementData(stationId, measurementNames, { start, end }) {
    return axios({
      url: baseURLv2 + `/measurement/timeseries/${stationId}/${start}/${end}/${measurementNames.join(',')}`,
      method: 'get',
      headers: Vue.prototype.$s.SessionAuthToken(),
    });
  },
};